import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Mail, Loader2 } from "lucide-react";
import api from "../api/axios";

export default function NewsletterUnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const token = searchParams.get("token") || "";

  const unsubscribe = async () => {
    if (!token || submitting) return;
    setSubmitting(true);
    try {
      const { data } = await api.post("/newsletter/unsubscribe", { token });
      setStatus({ type: "success", text: data.message });
    } catch (error) {
      setStatus({
        type: "error",
        text: error.response?.data?.message || "We couldn't process this unsubscribe link.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="mx-auto flex min-h-[50vh] max-w-2xl items-center px-6 py-16">
      <section className="w-full rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <Mail className="mx-auto text-cyan-700" size={32} />
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Newsletter preferences</h1>
        {status ? (
          <p role="status" className={`mt-3 text-sm ${status.type === "success" ? "text-emerald-700" : "text-red-600"}`}>
            {status.text}
          </p>
        ) : (
          <>
            <p className="mt-3 text-sm text-slate-600">
              {token ? "Confirm that you want to stop receiving MekPay newsletters." : "This unsubscribe link is missing its token."}
            </p>
            {token && (
              <button
                type="button"
                onClick={unsubscribe}
                disabled={submitting}
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {submitting && <Loader2 className="animate-spin" size={16} />}
                {submitting ? "Updating..." : "Unsubscribe"}
              </button>
            )}
          </>
        )}
        <Link to="/" className="mt-6 block text-sm font-medium text-cyan-700 hover:underline">Return to MekPay</Link>
      </section>
    </main>
  );
}